import { datadogRum } from '@datadog/browser-rum';
import { User } from 'api-clients/identity-server-api-client';
import { environment } from 'src/environments/environment';

export const initializeDDRUM = (user: User): void => {
  datadogRum.init({
    applicationId: environment.datadogApplicationId,
    clientToken: environment.datadogClientId,
    site: 'datadoghq.com',
    service: 'ezlynx',
    env: environment.environment.toLowerCase(),
    version: environment.appVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
  });

  datadogRum.startSessionReplayRecording();
  datadogRum.setUser({
    id: `${user.id}`,
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    userName: user.userName,
    organizationId: user.organizationId,
  });
};

